/**
 * Selects the appropriate vehicle image based on the offsetSharedVehicleImageByOne preference
 * and whether the vehicle is from a shared inventory source (different account ID).
 * 
 * @param {Object|undefined} vehicle - The vehicle object containing images and accountId (can be undefined)
 * @param {Object} preferences - Widget preferences object
 * @returns {Object|null} - The selected image object {uri: "..."} or null if no images available
 */
export const getVehicleImageUri = (vehicle, preferences = {}) => {
	if (!vehicle?.images || vehicle.images.length === 0) {
		return null;
	}

	// Check if offsetSharedVehicleImageByOne preference is enabled
	const shouldOffsetImage = preferences.offsetSharedVehicleImageByOne === 'true';
	
	// If preference is enabled, vehicle has multiple images, and it's either:
	// - a shared vehicle (regardless of account ID match), OR
	// - any vehicle when preference is true
	// Then use the second image (index 1), otherwise use first image (index 0)
	if (shouldOffsetImage && vehicle.images.length > 1) {
		return vehicle.images[1];
	}
	
	return vehicle.images[0];
};
